import {observer} from 'mobx-react';
import {Button} from 'shared/components/buttons';
import {FormattedMessage} from 'react-intl';
import {auth} from 'main/tools';
import {redirect} from 'shared/tools';

const PerformanceReviewTask = observer(({uiState}) => {
  const {task} = uiState;
  const {relatedAttributes = {}, subjectEmployee, assignedToCurrentUser} = task;
  const {reviewType, revieweeId, reviewSubmitted} = relatedAttributes;

  return (
    <div>
      <div className='mb3 jumbo'>
        <FormattedMessage
          id={`inbox.reviewee_explanation.${reviewType}${reviewSubmitted ? '_submitted' : ''}`}
          values={{name: subjectEmployee.name}}
        />
      </div>
      {(assignedToCurrentUser || auth.hasAccess('::MANAGE_PERFORMANCE_MANAGEMENT')) &&
        <Button onClick={() => redirect(`/reviews/reviewees/${revieweeId}/employee/${subjectEmployee.id}`)}>
          {reviewSubmitted ?
            <FormattedMessage id='inbox.Share Review'/> :
            <FormattedMessage id='inbox.Write Review'/>
          }
        </Button>
      }
    </div>
  );
});

export default PerformanceReviewTask;
